import { json, LoaderFunction } from 'react-router-dom'

import { mapAggregationsToFacets } from '@components/music/filter/utils/helpers'
import { Facet } from '@components/music/filter/utils/types'
import http from '@utils/http'
import PageRoutes from '@utils/page-routes'

export type MusicCategoriesResponse = {
  categories: Facet[] | null
}

const fetchCategories = async (): Promise<Facet[] | null> => {
  const resp = await http.loader.get(PageRoutes.musicCategoriesPath())
  if (!resp.categories) {
    return null
  }
  return mapAggregationsToFacets(resp.categories)
}

const musicCategoriesLoader: LoaderFunction = async () => {
  return json({ categories: await fetchCategories() })
}

export default musicCategoriesLoader
